import { z } from "zod";
import { LIMITS } from "./limits";
import { slugSchema } from "./post";

/** A message to Orla from the contact form. The Turnstile token proves a person sent it. */
export const contactMessageSchema = z.strictObject({
  name: z.string().trim().min(LIMITS.contactName.min).max(LIMITS.contactName.max),
  email: z.email().max(254),
  message: z.string().trim().min(LIMITS.contactMessage.min).max(LIMITS.contactMessage.max),
  turnstileToken: z.string().min(1).max(2_048),
  listingSlug: slugSchema.optional(),
});

/** The site is holding the message for Orla. It is not email: she collects it herself. */
export const contactReceiptSchema = z.object({ accepted: z.literal(true) });

export type ContactMessage = z.infer<typeof contactMessageSchema>;
export type ContactReceipt = z.infer<typeof contactReceiptSchema>;
